document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.fruit-hero-principal').forEach(hero => {
    const carousel = hero.querySelector('.fruit-hero-principal__carousel');
    const slides = hero.querySelectorAll('.fruit-hero-principal__slide');
    const prev = hero.querySelector('.fruit-hero-principal__arrow--prev');
    const next = hero.querySelector('.fruit-hero-principal__arrow--next');
    const dotsContainer = hero.querySelector('.fruit-hero-principal__dots');

    if (!carousel || slides.length <= 1) return;

    let index = 0;
    let autoplayTimer = null;

    const autoplayEnabled = hero.dataset.autoplay === 'true';
    const interval = parseInt(hero.dataset.interval, 10) || 5000;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      carousel.style.transform = `translateX(-${index * 100}%)`;
      updateDots();
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      autoplayTimer = setInterval(() => {
        goTo(index + 1);
      }, interval);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    /* ======================
       SETAS
       ====================== */
    prev?.addEventListener('click', () => {
      goTo(index - 1);
      startAutoplay();
    });

    next?.addEventListener('click', () => {
      goTo(index + 1);
      startAutoplay();
    });

    /* ======================
       DOTS (MOBILE)
       ====================== */
    let dots = [];

    if (dotsContainer) {
      slides.forEach((_, i) => {
        const btn = document.createElement('button');
        if (i === 0) btn.classList.add('is-active');
        btn.addEventListener('click', () => {
          goTo(i);
          startAutoplay();
        });
        dotsContainer.appendChild(btn);
      });

      dots = dotsContainer.querySelectorAll('button');
    }

    function updateDots() {
      dots.forEach(d => d.classList.remove('is-active'));
      dots[index]?.classList.add('is-active');
    }

    /* ======================
       SWIPE (MOBILE)
       ====================== */
    let startX = 0;
    let currentX = 0;

    carousel.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      stopAutoplay();
    });

    carousel.addEventListener('touchmove', e => {
      currentX = e.touches[0].clientX;
    });

    carousel.addEventListener('touchend', () => {
      const diff = startX - currentX;

      if (Math.abs(diff) > 50) {
        goTo(diff > 0 ? index + 1 : index - 1);
      }

      startAutoplay();
    });

    /* ======================
       INIT
       ====================== */
    startAutoplay();
  });
});
